<template>
  <div>
    <div
      class="modal fade"
      id="DSPPopUp"
      tabindex="-1"
      role="dialog"
      aria-labelledby="openModal"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content campaign-g-addedit"
          style="width: 1000px; height: 260px; margin-left: -49px"
        >
          <div class="modal-header" style="flex: 0 0 auto">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Add DSP
            </h5>
            <button type="button" class="close" data-dismiss="modal" @click="resetAction">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="margin-top: 25px">
            <div class="spinner-border" v-if="isLoading" style="margin:auto;display:block" ></div>
            <div v-else>
              <form v-on:submit.prevent>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label"
                    >Advertiser Name <sup>*</sup></label
                  >
                  <div class="col-sm-7 pr-5">
                    <input
                      type="text"
                      name="dspAdvertiserName"
                      v-model="dsp.advertiser_name"
                      class="form-control"
                      id="dsp_advertiser_name"
                      placeholder="Amazon DSP Advertiser Name"
                      style="height: 40px"
                      autocomplete="off"
                    />
                    <span
                      class = "no-data-style"
                      v-if = "!isNameSet && isSubmitted">
                      Provide the required field
                    </span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label"
                    >Advertiser Id <sup>*</sup></label
                  >
                  <div class="col-sm-7 pr-5">
                    <input
                      type="number"
                      name="dspAdvertiserId"
                      v-model="dsp.advertiser_id"
                      class="form-control"
                      id="dsp_advertiser_id"
                      placeholder="DSP Advertiser Id (Numeric)"
                      style="height: 40px"
                      autocomplete="off"
                    />
                    <span
                      class = "no-data-style"
                      v-if = "!isIdSet && isSubmitted">
                      Provide the required field
                    </span>
                    <span
                      class = "no-data-style"
                      v-else-if = "isIdDuplicate && isSubmitted">
                      Id is already present
                    </span>                    
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="modal-footer" style="flex: 0 0 auto">
            <div class="mt-2" style="text-align: center">
              <button
                type="button"
                class="btn btn-primary"
                @click="saveDSP()"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  name: "DSPPopUp",
  props: ["DSPList","client_id","index"],
  data() {
    return {
      dsp: {
        advertiser_name: "",
        advertiser_id: "",
      },
      isLoading: false,
      isSubmitted:false
    };
  },
  methods: {
    saveDSP() {
      this.isSubmitted = true
      if(!this.isNameSet || !this.isIdSet || this.isIdDuplicate){
        return ;
      }
      let vm = this;
      this.isLoading = true;
      let payload = {
        dsp:this.dsp
      }
;
      this.$store
        .dispatch("accounts/saveDSP", payload)
        .then((res) => {
          if (Object.keys(res).length!=0) {
            this.isLoading = false;
            vm.$emit("updateAddedDSPInfo", res.data,vm.index);
            vm.resetAction();
          } 
        });
    },
    resetAction(){
      this.dsp = {};
      this.isLoading = false;
      this.isSubmitted = false
    }
  },
  computed:{
    isNameSet(){
      return !!this.dsp.advertiser_name;
    },
    isIdSet(){
      return !!this.dsp.advertiser_id
    },
    isIdDuplicate(){
      let idArr = this.DSPList.map(x=>x.advertiser_id);
      let isDuplicate = idArr.includes(this.dsp.advertiser_id);
      return isDuplicate
    }

  },
  Component: {
    moment,
  },
};
</script>

<style>
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0; 
}
</style>
